import React from 'react';
import PropTypes from 'prop-types';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';

const SrPartnerApprovalFormStepSimple = ({
  formikBag,
  formFields,
}) => {
  return (
    <SrCard>
      {formFields.map((formField, index) => (
        <div key={formField.id}>
          <SrBox>
            <SrFormikField
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
              margin={index === 0 ? '0px' : null}
            />
          </SrBox>
        </div>
      ))}
    </SrCard>
  );
};

SrPartnerApprovalFormStepSimple.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrPartnerApprovalFormStepSimple.displayName = 'SrPartnerApprovalFormStepSimple';

export default SrPartnerApprovalFormStepSimple;
